export default __webpack_public_path__ + "media/images/brands/expmessenger/services/service-01-f504062e39dbcabee434815ce4b87a55.jpg";